// Path: ./src/app/pages/CreateFlyerItemPage/styled.ts
import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 20px;

  @media (max-width: 899px) {
    padding: 10px;
  }
`;

export const LeftSideTop = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;
export const LeftSideBottom = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  @media (max-width: 899px) {
    height: auto;
    overflow: visible;
  }
`;

export const StartDate = styled.div`
  margin-right: 12px;
`;

export const DateTableWrapper = styled.div`
  display: block;
`;

export const LeftButtonSection = styled.div`
  width: 100%;
  margin-bottom: 6px;
`;
export const TopApp = styled.div``;

export const ImageListLabel = styled.div`
  font-size: 1rem;
  font-weight: 600;
  margin-left: 1rem;
`;

interface CreateFlyerButtonWrapperProps {
  isVisible?: boolean;
}

export const CreateFlyerButtonWrapper = styled.div<CreateFlyerButtonWrapperProps>`
  position: absolute;
  bottom: -2px;
  width: 100%;
  justify-content: center;
  z-index: 200;
  display: ${(props) => (props.isVisible ? "flex" : "none")};
`;

export const actionButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "8px",
  padding: { xs: "6px 10px", sm: "6px 12px" },
  fontSize: { xs: "12px", sm: "13px" },
  height: { xs: "32px", sm: "34px" },
  minWidth: { xs: "100%", sm: 136, md: 151 },
  maxWidth: { xs: "100%", sm: 188 },
  width: { xs: "100%", sm: "auto" },
  flex: { xs: "1 1 100%", sm: "0 0 auto" },
  whiteSpace: "nowrap" as const,
  marginTop: "0px",
};
